import { useEffect, useState } from "react";

// Election Day: Monday, October 26, 2026, 12:00 AM America/Toronto (EDT = UTC-4; DST ends Nov 1, 2026)
const TARGET = new Date("2026-10-26T00:00:00-04:00").getTime();

const useCountdown = () => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const remaining = TARGET - now;
  const diff = Math.max(0, remaining);
  return {
    done: remaining <= 0,
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000) % 24,
    minutes: Math.floor(diff / 60000) % 60,
    seconds: Math.floor(diff / 1000) % 60,
  };
};

const pad = (n) => String(n).padStart(2, "0");

const Block = ({ value, label, testid }) => (
  <span
    data-testid={testid}
    className="flex min-w-9 flex-col items-center rounded-md bg-pine-700/10 px-2 py-1 leading-none"
  >
    <span className="font-serif text-sm font-semibold tabular-nums text-pine-700">{pad(value)}</span>
    <span className="mt-0.5 font-mono text-[8px] uppercase tracking-[0.15em] text-terra-500">{label}</span>
  </span>
);

const CountdownStrip = () => {
  const { done, days, hours, minutes, seconds } = useCountdown();

  return (
    <div data-testid="countdown-strip" className="mt-16 border-b border-pine-700/10 bg-paper sm:mt-[72px]">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-5 py-1.5 sm:justify-end sm:gap-4 sm:px-8">
        {done ? (
          <p className="font-serif text-sm italic text-pine-700" data-testid="countdown-done">
            It’s Election Day. Ward 11 votes today.
          </p>
        ) : (
          <>
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink/45">Election Day</span>
            <span className="flex items-center gap-1.5">
              <Block value={days} label="Days" testid="strip-days" />
              <Block value={hours} label="Hrs" testid="strip-hours" />
              <Block value={minutes} label="Min" testid="strip-minutes" />
              <Block value={seconds} label="Sec" testid="strip-seconds" />
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default CountdownStrip;
